// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Mclb","row":"Node_row__2u74O","label":"Node_label__3MNgO","footer":"Node_footer__2JIgi"};